export default {
  formItemSection: {
    padding: '10px 0',
  },
  formActionSection: {
    padding: '10px 0',
    display: 'flex',
  },
  formActionButtonFullWidth: {
    width: '100%',
  },
  formControl: {
    textAlign: 'center',
  },
  input: {
    fontSize: '32px',
    color: 'black',
    height: '50px',
  },
  inputLabel: {
    padding: '0 0 10px 0',
  },
  formBox: {
    margin: '20px',
    padding: '20px',
  },
  fieldInputButtonWrapper: {
    display: 'flex',
    '& button': {
      marginLeft: '10px',
    },
  },
  fieldUpdatesCheckboxLabel: {
    marginLeft: '0',
    marginRight: '5px',
  },
  fieldUpdatesCheckboxLabelBold: {
    '& span': {
      fontWeight: 'bold',
    },
  },
  formButtonResponseContainer: {
    margin: '20px 0',
    '& button': {
      fontSize: '1.1em',
    },
  },
  formButtonResponseContainer_inline: {
    margin: '0',
    '& button': {
      padding: '10px 25px',
      fontSize: '0.8em',
    },
  },
  circularProgress: {
    color: '#000',
    fontSize: '0.65em',
    fontWeight: 'bold',
  },
};
